export const STATS_JOUEUR_CONFIG = {
    PAGE_SIZE: 10,
}
